import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';

export const $Didactic = styled.div<{
  $withBottomMargin?: boolean;
}>`
  display: block;

  color: ${({ theme }) => theme.colors.paragraphTextColor};
  ${fontStyle('xs')};

  margin-bottom: ${({ $withBottomMargin = true }) =>
    $withBottomMargin ? `${spacing(3.5)} !important` : null};
  white-space: pre-wrap;

  text-overflow: ellipsis;
  overflow: hidden;

  &:first-letter {
    text-transform: uppercase;
  }
`;
